import * as React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react'
import ReportsService from '../../../Services/ReportsService'
import { withRouter } from 'react-router'
import UserStore from '../../../Stores/UserStore'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { history } from '../../../Routing'

export interface IReportPageProps {
    localizationStore?: LocalizationStore
    userStore?: UserStore
}

@inject('localizationStore')
@inject('userStore')
@observer
class ReportPage extends React.Component<any> {
    constructor(props: any) {
        super(props)

        if (!UserStore.getInstance().checkSession) {
            history.push('/login')
        }
    }

    render() {
        const { localizationStore } = this.props

        return (
            <div className="reportWrapper">
                <div>
                    <label>{
                        localizationStore!.t(
                            ReportsService.getIframeLocalizationKey(this.props['match']!['params']['report']))}
                    </label>
                </div>
                <iframe
                    className="iframe-report"
                    src={ReportsService.getIframe(this.props['match']!['params']['report'])}
                    max-width="100%"
                    width="100%"
                    max-height="1300"
                    frameBorder="0"
                    allowFullScreen
                />
            </div>
        )
    }
}

export default withRouter(ReportPage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Reports/ReportPage.tsx